import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Studios banner',
    },
  },
};


export function StudiosHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="studioshero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Studios banner"
    >
      <InnerPageHeroSubtitle path="studioshero.subtitle" />
      <RichTextContent
        path="studioshero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="studioshero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="studioshero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'StudiosHero',
  displayName: 'Studios Hero',
  tokens: {
    'studioshero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Studios</p>',
    },
    'studioshero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue:
        '<p>Studio Apartments in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
      description:
        'Short, SEO-style headline for the studio floor plans page (e.g. "Studio Apartments in Tigard, OR").',
    },
  },
  slotGroups: {
    'studioshero.bg_image': bgImageDef,
  },
};

(StudiosHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default StudiosHero;
